import { createContext, useContext } from 'react';

import type { CadenceStepTypePure } from '@poseidon/components/CGStep';
import type { StepData } from '@poseidon/components/CGStep/CTSContentEditingPure';
import type { TipTapDocument, TipTapVariable } from '@poseidon/components/Input2/TipTapInput';

/** What every day card of a contact's sequence timeline needs, however deep in a branch it sits. */
export interface SequenceTimelineContextValue {
  /** The step whose inline editor is open (its override key). */
  editingKey: string | null;
  onEdit: (key: string) => void;
  onCancelEdit: () => void;
  /** Save this contact's copy of a step — subject / body only. */
  onSave: (key: string, data: StepData) => Promise<void>;
  /** Complete the reminder / call to-do the contact is parked on at `key`. */
  onMarkDone: (key: string, type: CadenceStepTypePure) => void;
  variables?: TipTapVariable[];
  documents?: TipTapDocument[];
}

export const SequenceTimelineContext = createContext<SequenceTimelineContextValue | null>(null);

export function useSequenceTimeline(): SequenceTimelineContextValue {
  const ctx = useContext(SequenceTimelineContext);
  if (ctx == null) throw new Error('useSequenceTimeline must be used inside <ContactSequenceTimeline>');
  return ctx;
}
